<template lang="jade">
  .navbar
    el-popover(class="userinfo", ref="popoveruser", v-model="isShowUserInfoPopover", placement="bottom", trigger="click")
      .referral-userinfo-popover
        label(for="user-name") User name
          span(id="user-name") {{user.username}}
        label(for="user-email") Email
          span(id="email") {{user.email}}
        label(for="user-status") Status
          span(id="user-status") {{user.status}}
    el-menu(default-active='1', mode='horizontal')
      img.logo(:src="imgVipkidLogo", style="width:110px;height:32px")
      el-menu-item(index='3', style="padding-right:0")
        b(@click="onLogout") Logout
      el-menu-item.arrow(index='2')
        span(v-popover:popoveruser='')
          span(style="margin-right:5px") My account
          i(v-show="!isShowUserInfoPopover").el-icon-arrow-down
          i(v-show="isShowUserInfoPopover").el-icon-arrow-up
      el-menu-item(index='1')
        el-button.copy-link(@click.prevent.stop="onCopyReferralLink") Copy Referral Link
          <svg class="icon-link" width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><g fill-rule="evenodd"><path d="M6.248 8.934l-2.423 2.422a3.435 3.435 0 0 0 0 4.854 3.434 3.434 0 0 0 4.854 0l2.986-2.986a3.435 3.435 0 0 0-.208-5.044l-1.41 1.373a1.653 1.653 0 0 1 .241 2.532L7.54 14.834a1.653 1.653 0 0 1-2.337-2.337l1.433-1.434a1.608 1.608 0 0 1-.208-.313l-.038-.074c-.262-.51-.298-1.158-.14-1.742z"/><path d="M13.707 11.182L16.12 8.77a3.435 3.435 0 0 0 0-4.854 3.434 3.434 0 0 0-4.853 0L8.28 6.902a3.435 3.435 0 0 0 .5 5.266l1.427-1.428a1.653 1.653 0 0 1-.55-2.699l2.749-2.749a1.653 1.653 0 0 1 2.337 2.337L13.31 9.064l.307.824c.144.386.167.846.09 1.295z"/></g></svg>
</template>

<style lang="stylus">
  .navbar
    .el-menu
      margin: 0 -50px
      padding: 0 50px
      border-bottom: 1px solid #eaeaea
    .el-menu-item.arrow span i:before
      position: relative
      top: 1px

    // overwrite element styles
    .el-menu-item
      border-bottom: none
    .el-menu--horizontal.el-menu--dark .el-submenu .el-menu-item.is-active, .el-menu-item.is-active
      color: inherit

  .referral-userinfo-popover
    label
      font-size: 12px
      color: #666
    span
      font-size: 16px
      display: block
      margin-bottom: .5em
  .navbar
    .logo
      width: 94px
      height: 30px
      margin-top: 16px
    .el-menu
      line-height: 70px
      height: 70px
    .el-menu-item
      float: right
    .copy-link
      height: 36px
      position: relative
      text-indent: 1.2em
      svg
        position: absolute
        left: 10px
        top: 7px
    .icon-link
      float: left
      fill: #73BA00
      position: relative
      top: -2px
      right: 2px
    .copy-link:hover .icon-link, .copy-link:focus .icon-link
      fill: white
</style>

<script>
import { setClipboardText, ElementMessageMixin, browser } from 'api/utils.js'
import Referral from 'api/referral.api.js'
export default {
  mixins: [ElementMessageMixin],
  name: 'navbar',
  props: ['user'],
  data () {
    return {
      imgVipkidLogo: require('assets/images/vipkid-logo.png'),
      isShowUserInfoPopover: false
    }
  },
  methods: {
    /**
     * copy referral link to clipboard
     * fallback to display a dialog for manually copy when failed
     */
    onCopyReferralLink () {
      console.log(this.user)
      const id = this.user.id
      const url = `https://www.vipkid.com/teach?partnerId=${id}`
      const showDialog = () => {
        // IE<=11,Safari早期版本无法拷贝
        this.$prompt('Please copy it manually.', 'Infomation', {
          inputPlaceholder: url,
          confirmButtonText: 'OK',
          showCancelButton: false
        }).catch(_ => _)
        setTimeout(_ => {
          const input = document.querySelector('.el-message-box input')
          input.value = url
          input.placeholder = ''
          input.focus()
          input.select()
        }, 300)
      }
      if (browser.msie && browser.version <= '11.0') {
        // IE<=11 will show a clipboard permission request dialog
        // which will make textarea created in setClipboardText
        // visible and this is not acceptable, so fallback to copy manually.
        showDialog()
      } else if (setClipboardText(url)) {
        this.$success('Copied Successfully!')
      } else {
        showDialog()
      }
    },
    /**
     * Logout
     */
    onLogout () {
      Referral.logout()
        .then(() => {
          this.$router.push({ path: '/login' })
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// navbar.vue?1910e170